<template>
    <div>
        <div class="d-none d-lg-block">
            <v-row justify="center" align="baseline" class="ma-n4">
                <template v-for="(tab, index) in tabs">
                    <v-col cols="auto" :key="`${tab}-text`" class="d-flex align-center pa-4">
                        <v-btn
                            text
                            class="px-16 py-8"
                            v-bind="{
                                style: {
                                    opacity: tab == value ? 1 : 0.3,
                                    pointerEvents: 'none',
                                },
                            }"
                            v-on="{
                                click() {
                                    // $emit('input', tab);
                                },
                            }"
                        >
                            <v-avatar color="grey lighten-4">
                                <span class="page-text--sm">
                                    {{ index + 1 }}
                                </span>
                            </v-avatar>
                            <span class="ml-8">
                                {{ TABS[tab]?.text }}
                            </span>
                        </v-btn>
                    </v-col>
                    <v-col cols="auto" class="pa-4" :key="`${tab}-next`" v-if="index < tabs.length - 1">
                        <v-icon v-bind="{ style: { opacity: 0.3 } }">
                            mdi-chevron-right
                        </v-icon>
                    </v-col>
                </template>
            </v-row>
        </div>
        <div class="d-block d-lg-none">
            <v-card-title class="pa-0 justify-center align-center" style="gap: 8px">
                <span> {{ tabs.findIndex((item) => item == tab) + 1 }}. </span>
                <span> {{ TABS[tab].text }} </span>
            </v-card-title>
        </div>
    </div>
</template>

<script>
import { EMPLOYMENT_FIELD_TYPES, initEmploymentContract } from "@/assets/variables";

import { TABS } from "../lib";

export default {
    props: {
        value: { type: String, default: TABS.VIEW.value },

        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        contract: { type: Object, default: initEmploymentContract },
    },
    data: () => ({
        tab: TABS.VIEW.value,
        TABS,
    }),
    computed: {
        tabs() {
            let tabs = Object.keys(TABS);

            let hasFileField = this.contract.fields_employee.some(({ type }) => type == EMPLOYMENT_FIELD_TYPES.FILE.value);

            if (hasFileField) return tabs;
            else return tabs.filter((tab) => tab != TABS.FILE.value);
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.tab = this.value;
        },
    },
};
</script>

<style lang="scss" scoped>
.v-avatar {
    width: 28px !important;
    height: 28px !important;
}
</style>
